











import { defineComponent, PropType, ref } from '@vue/composition-api'

import OutputConditionGroup from '@/components/organisms/h/outputCond/OutputConditionGroup.vue'
import {
  outputConditionGroupOutputCondition,
  outputCondUseInfoList,
  autoorderStopOutputCondition,
} from '@/types/entities'

export default defineComponent({
  components: {
    OutputConditionGroup,
  },
  props: {
    outputUseList: {
      type: Array as PropType<outputCondUseInfoList>,
      default: () => [],
    },
  },
  setup(_, context) {
    const changeOutputCondition = (
      params: outputConditionGroupOutputCondition
    ) => {
      const cond: autoorderStopOutputCondition = {
        storeOutput: params.storeOutput || [],
        itemOutput: params.itemOutput || [],
        delOutput: params.delOutput || [],
      }
      context.emit('change-output-condition', cond)
    }

    const radioDisabled = true
    return { changeOutputCondition, radioDisabled }
  },
})
